function showAlert(id) {
  id = prompt('Javascript. Your number: ');
  if (id) {
    document.getElementById('test').innerText = 'HUB ' + id;
    document.getElementById('test').setAttribute("data-id", id);
    document.getElementById('test').click();
  }
}
